module.exports = __webpack_public_path__ + "img/eaaf176.jpg";